import { render, staticRenderFns } from "./PencilOff.vue?vue&type=template&id=6cde7d27&"
import script from "./PencilOff.vue?vue&type=script&lang=js&"
export * from "./PencilOff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports